"use client";

import { Career } from "@/app/actions/careers";
import { FadeInStaggerItem } from "@/components/ui/motion";
import TiltCard from "@/components/ui/TiltCard";
import { ArrowUpRight } from "lucide-react"; // Import ArrowLeft just in case, though not used here directly
import Link from "next/link";

export default function JobItem({ job }: { job: Career }) {
    return (
        <FadeInStaggerItem>
            <Link href={`/careers/${job.id}`}>
                <TiltCard className="group p-8 bg-white border border-gray-200 shadow-md hover:shadow-xl transition-all cursor-pointer">
                    <div className="flex flex-col w-full">
                        <div className="flex items-start justify-between w-full">
                            <div className="flex-1">
                                <h3 className="text-2xl font-bold mb-2 group-hover:text-blue-600 transition-colors">{job.title}</h3>
                                <div className="flex flex-wrap gap-2 mb-3">
                                    <span className="bg-gray-50 border border-gray-100 px-3 py-1 rounded-full text-sm text-gray-600">
                                        {job.type}
                                    </span>
                                    <span className="bg-gray-50 border border-gray-100 px-3 py-1 rounded-full text-sm text-gray-600">
                                        {job.location}
                                    </span>
                                    <span className="bg-gray-50 border border-gray-100 px-3 py-1 rounded-full text-sm text-gray-600">
                                        {job.experience}
                                    </span>
                                </div>
                                <div className="flex flex-wrap gap-2">
                                    {job.skills?.slice(0, 3).map((skill, i) => (
                                        <span
                                            key={i}
                                            className="text-xs bg-gray-100 px-2 py-1 rounded-md text-gray-500"
                                        >
                                            {skill}
                                        </span>
                                    ))}
                                    {job.skills && job.skills.length > 3 && (
                                        <span className="text-xs bg-gray-100 px-2 py-1 rounded-md text-gray-500">
                                            +{job.skills.length - 3}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="flex items-center gap-4 ml-4">
                                <div className="p-2 rounded-full bg-gray-50 group-hover:bg-black group-hover:text-white transition-colors">
                                    <ArrowUpRight className="w-5 h-5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </TiltCard>
            </Link>
        </FadeInStaggerItem>
    );
}
